/* The mockup's `.color-row`: a 32px picker, then the hexadecimal text. */
.row {
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  gap: var(--space-2);
  align-items: center;
}

.picker {
  inline-size: 32px;
  block-size: 32px;
  padding: 0;
  border: 1px solid var(--border-control);
  border-radius: var(--radius-control);
  background: none;
  cursor: pointer;
}

.picker:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.picker:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
